import { TelegramAdapter } from '@alveon/shared/platform/types';

export const webTelegramAdapter: TelegramAdapter = {
  getInitData(): string | null {
    return window.Telegram?.WebApp?.initData || null;
  },
  hasTelegram(): boolean {
    return !!window.Telegram?.WebApp;
  }
};

